export const hashtagBank = {
  glow: [
    "#glowup",
    "#glowvibes",
    "#glowingskin",
    "#aestheticvibes",
    "#shinebright",
    "#innerlight",
    "#selflove",
    "#glowseason",
    "#glowgetter",
    "#lightwithin",
  ],

  love: [
    "#lovequotes",
    "#selflove",
    "#loveyourself",
    "#relationshipgoals",
    "#couplevibes",
    "#heartfelt",
    "#loveislove",
    "#romanticenergy",
    "#spreadlove",
  ],

  classy: [
    "#classyvibes",
    "#keepitclassy",
    "#luxurylife",
    "#elegance",
    "#sophisticated",
    "#highfashion",
    "#classygirl",
    "#refinedtaste",
  ],

  bold: [
    "#bebold",
    "#boldmoves",
    "#bravevibes",
    "#confidence",
    "#fearless",
    "#daringgreatly",
    "#strongvibes",
    "#levelup",
  ],

  vibes: [
    "#goodvibesonly",
    "#positivity",
    "#moodoftheday",
    "#vibespeaks",
    "#vibesonvibes",
    "#vibing",
    "#energyflows",
    "#highvibes",
  ],

  motivation: [
    "#motivationdaily",
    "#inspiration",
    "#hustlemode",
    "#riseandgrind",
    "#grindtime",
    "#focusmode",
    "#makeithappen",
    "#yougotthis",
  ],

  shine: [
    "#keepShining",
    "#shineon",
    "#shinebrightlikeadiamond",
    "#lightupyourworld",
    "#glitterandglow",
    "#shiningthrough",
  ],

  sunset: [
    "#sunsetvibes",
    "#chasingSunsets",
    "#goldenhour",
    "#sunsetlover",
    "#skylover",
    "#eveningvibes",
  ],

  selflove: [
    "#selflove",
    "#selfcare",
    "#mentalhealthmatters",
    "#loveyourself",
    "#selfgrowth",
    "#innerpeace",
  ],

  unstoppable: [
    "#unstoppable",
    "#cantstopwontstop",
    "#powerfulenergy",
    "#fearlessenergy",
    "#breakthelimits",
    "#ownyourpower",
  ],

  weekend: [
    "#weekendmood",
    "#sundayvibes",
    "#chilltime",
    "#weekendlover",
    "#goodtimes",
    "#weekendfun",
  ],

  confidence: [
    "#confidenceiskey",
    "#bossenergy",
    "#ownit",
    "#slayallday",
    "#queenenergy",
    "#alphamindset",
  ],

  hustle: [
    "#hustlehard",
    "#workmode",
    "#entrepreneurlife",
    "#stayhumblehustlehard",
    "#businessmindset",
    "#hustleandgrind",
  ],

  positivity: [
    "#positivity",
    "#positiveenergy",
    "#radiatepositivity",
    "#goodenergy",
    "#lightup",
    "#choosejoy",
  ],

  aesthetic: [
    "#aesthetic",
    "#aestheticvibes",
    "#softaesthetic",
    "#moonaesthetic",
    "#sunshineaesthetic",
  ],

  travel: [
    "#wanderlust",
    "#adventureawaits",
    "#travelvibes",
    "#exploretheworld",
    "#passportready",
    "#earthwanderer",
  ],

  quotes: [
    "#quoteoftheday",
    "#lifequotes",
    "#moodquotes",
    "#deepquotes",
    "#thoughtsoftheday",
  ],

  default: [
    "#dailyvibes",
    "#instadaily",
    "#instagood",
    "#lifequotes",
    "#trendingnow",
    "#viralquote",
    "#instagramcaptions",
  ],
};

export const complimentLines = [
  "This image feels calm and refreshing ✨",
  "Absolutely stunning visual 👌",
  "Perfect for wallpapers 📌",
  "Such peaceful vibes 🌿",
  "The details are breathtaking 🔥",
  "Can't stop looking at this! 👀",
  "Feels magical and aesthetic ✨",
  "A masterpiece of colors 🎨",
  "Saved-worthy image 😍",
  "Dreamy and cinematic ✨",
];

let contents = [
  // 🌿 Calm & Nature (ONLY aesthetic-friendly)
  "Beach Vibes",
  "Sunsets and Sunrises",
  "Mountain Views",
  "Rainy Days",
  "Snow and Winter",
  "Nature Trails",
  "Tropical Paradise",
  "Skyline Views",
  "Desert Landscapes",
  "Dreamy Landscapes",
  "Cinematic Shots",

  // ✨ Aesthetic & Mood
  "Minimalism",
  "Vintage Vibes",
  "Cozy Corners",
  "Morning Light",
  "Night Lights",
  "Rain Window",
  "Happy Patterns",
  "Aesthetic Desks",
  "Modern Bedrooms",
  "Workspace Inspiration",
  "Color Palettes",
  "Typography Design",
  "Painting Textures",
  "Soft Pastels",
  "Neon Aesthetics",
  "Dark Aesthetic",

  // ❤️ Emotional & Relationship Vibes
  "Love and Romance",
  "Couples",
  "Romantic Moments",
  "Date Night",
  "Sibling Love",
  "Family Time",
  "Friendship Goals",
  "Cute Gestures",

  // 🌍 Travel & Adventure
  "Travel Destinations",
  "Road Trips",
  "Adventure Travel",
  "Cultural Heritage",
  "Cityscapes",
  "Street Photography",

  // 🎨 Art & Creativity
  "Art and Creativity",
  "Abstract Art",
  "Street Art",
  "Digital Art",
  "Creative Portraits",
  "Photography Inspiration",
  "DIY and Crafts",

  // 💛 Motivation & Self Growth
  "Quotes and Inspiration",
  "Motivation and Productivity",
  "Self Growth",
  "Mindfulness and Meditation",
  "Morning Routines",
  "Focus and Study Setup",

  // ☕ Everyday Aesthetic Life
  "Coffee and Cafes",
  "Books and Coffee",
];

